/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useRouter } from 'next/router'
import EverlaneLink from '@everlane/link'
import Image from 'components/core/Image'
import CloseButton from 'components/core/CloseButton'
import styles from './styles.module.scss'

const formatHours = hours => {
  return hours.split('\n').map(hour => {
    const index = hour.search(/\d/)
    const time = hour.slice(index)
    const days = hour.slice(0, index)
    return [days, time]
  })
}

const Time = ({ time, noBreak = false }) => {
  const [days, hours] = time

  return (
    <time className={styles.store__time}>
      {days}
      {!noBreak && <br />}
      {hours}
    </time>
  )
}

const Event = ({ event }) => {
  const { title, description, hours, url, ctaText } = event
  return (
    <div className={styles.event}>
      <h4 className={styles.event__title}>{title}</h4>
      <p className={styles.event__description}>{description}</p>
      {hours.length > 0 &&
        formatHours(hours)?.map((h, i) => <Time time={h} key={`event${i}`} noBreak />)}
      <EverlaneLink
        href={url}
        target="_blank"
        className={styles.event__cta}
        chevron
        underlinedInlineWhite
      >
        {ctaText}
      </EverlaneLink>
    </div>
  )
}

const Store = ({
  images = [],
  streetAddress,
  city,
  regionCode,
  postalCode,
  name,
  hours,
  storefrontEvents,
  setStoreToShow,
  phone,
}) => {
  const mapLink = `https://www.google.com/maps/place/${encodeURIComponent(
    streetAddress,
  )},+${encodeURIComponent(city)},+${encodeURIComponent(regionCode)},+${encodeURIComponent(
    postalCode,
  )}`

  const router = useRouter()

  const handleClick = () => {
    router.push('/stores', '', { shallow: true, scroll: false })
    setStoreToShow(null)
  }

  return (
    <section className={styles.store__container}>
      <CloseButton className={styles.store__close} onClick={handleClick} />

      <div className={styles['store__image-container']}>
        <Image
          height={334}
          width={334}
          src={images[0]?.path}
          containerClassName={styles.store__image}
          alt={name}
        />
        {!!images[1] && (
          <Image
            height={334}
            width={334}
            src={images[1]?.path}
            containerClassName={styles.store__image}
            alt={name}
          />
        )}
      </div>
      <div className={styles.store__copy}>
        <div className={styles.store__details}>
          <h2 className={styles.store__name}>{name}</h2>

          <div className={styles['store__details-top']}>
            <address className={styles.store__address}>
              {streetAddress}
              <br />
              {city}, {regionCode} {postalCode}
              <br />
              <div>{phone}</div>
              <a href={mapLink} target="_blank" rel="noreferrer">
                Get Directions
              </a>
            </address>

            <div className={styles.store__hours}>
              {hours.length > 0 &&
                formatHours(hours)?.map((h, i) => <Time time={h} key={`time${i}`} />)}
            </div>
          </div>
        </div>

        <div className={styles.store__events}>
          {storefrontEvents?.length > 0 &&
            storefrontEvents.map(event => <Event key={event.title} event={event} />)}
        </div>
      </div>
    </section>
  )
}

export default Store
